import {BsTrash} from 'react-icons/bs';

import styled from 'styled-components';

export const ImageWrapper = styled.div`
  position: relative;
  display: inline-block;
  border-radius: 8px;
  overflow: hidden;
  width: 150px;
  height: 150px;
  padding: 15px;
  flex-shrink: 0;
  background-color: ${(props) => props.theme.colors.card};
`;

export const StyledImg = styled.img`
  cursor: pointer;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const DeleteContainer = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  background: #fca5a5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 6px;
`;

export const DeleteIcon = styled(BsTrash)`
  cursor: pointer;
  border-radius: 50%;
  padding: 6px;
  color: #7f1d1d;
`;

export const PreviewImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;
